import axios from "axios";
import React from "react";
import { jsonHeader } from '../util/GeneralUtil'
const apiUrl = process.env.REACT_APP_API_URL;


async function getMaster(payload) {
    const result = await axios.post(apiUrl + "/admin/dropdown/getmasters",payload,{
        headers: jsonHeader}
    );
    return result.data || [];
}

async function getUsers(payload) {
    const resultuser = await axios.post(apiUrl + "/admin/getusers",payload,{
        headers: jsonHeader}
    );
    return resultuser.data || [];
}

async function getScript(payload) {
    const resultuser = await axios.post(apiUrl + "/admin/getblockedscripts",payload,{
        headers: jsonHeader}
    );
    return resultuser.data || [];
}

export const BlockedscriptServices = {
    getMaster,
    getUsers,
    getScript
}